import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine'
import useMediaQuery from '@mui/material/useMediaQuery'
import style from './block.module.scss'
import MainHeader from './Main'
import TopHeader from './Top'
import Inspector from './Inspector'

const Header = ({ langs, menus, linkDonation, labelDonation }) => {
    const { isEditing } = useEditor()
    useInspectorControl(Inspector)
    const desktop = useMediaQuery(`(min-width:${style.tabletBreakpoint})`)

    return (
        <BlockWrapper.Header className={style.header}>
            {desktop && <TopHeader langs={langs} menu={!isEditing && menus.top} />}
            <MainHeader
                menu={!isEditing && menus.main}
                langs={langs}
                responsiveMenu={!isEditing && menus.top}
                donation={{
                    link: linkDonation,
                    label: labelDonation,
                }}
            />
        </BlockWrapper.Header>
    )
}

export default defineBlock({
    Block: Header,
    smartProps: {
        linkDonation: smartProps.string.withDefault(''),
        labelDonation: smartProps.string.withDefault('Faire un don'),
    },
    setup: {
        title: 'Header',
    },
})
